import log from 'salvo-lite/log'

class Collection {
    constructor (theme) {
        this._theme = theme
        this._prodContainer = document.querySelector('.boost-pfs-filter-products')
        this._clear = document.querySelector('[data-clear-filters]')
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        this._observer()
        if (this._clear) {
            this._clear.addEventListener('click', e => {
                if (document.querySelector('.boost-pfs-filter-clear-all')) {
                    document.querySelector('.boost-pfs-filter-clear-all').click()
                } else if (document.querySelector('.boost-pfs-filter-clear')) {
                    document.querySelector('.boost-pfs-filter-clear').click()
                    this._clear.click()
                }
            })
        }
    }
    _observer () {
        const config = { childList: true }
        const callback = (mutationsList, observer) => {
            for (let mutation of mutationsList) {
                this._doComponents(mutation)
            }
        }
        let observer = new MutationObserver(callback)
        observer.observe(this._prodContainer, config)
    }
    _doComponents (mutation) {
        let products = this._prodContainer.querySelectorAll('.product-item')
        for (let product of products) {
            this._theme.registerComponents(product)
        }
    }
}

export default Collection



// WEBPACK FOOTER //
// ./src/resources/scripts/pages/Collection.js